import {useQuery} from '@tanstack/react-query';
import {authHeaders,fetchImpl} from '../lib/api';
import {env} from '../lib/env';
import {day} from '../lib/format';
import {useT} from '../lib/i18n';

interface Deliverable {kind:'completion'|'warranty';label:string;url:string;recorded_at:string|null}
async function readDeliverables(ref:string):Promise<Deliverable[]>{
  if(env.mock)return [];
  const r=await fetchImpl(`${env.apiBase}/api/jobs/${encodeURIComponent(ref)}/deliverables`,{headers:await authHeaders()});
  const body=await r.json() as {data?:Deliverable[];error?:string};
  if(!r.ok||!body.data)throw Error(body.error??`api ${r.status}`);
  return body.data;
}

/** Historical PDFs remain immutable. A new document workflow must create a
 *  separately versioned artifact rather than rewriting one of these links. */
export function JobDeliverables({jobRef}:{jobRef:string}){
  const {t}=useT();
  const q=useQuery({queryKey:['job',jobRef,'deliverables'],queryFn:()=>readDeliverables(jobRef)});
  return <div className="mt-3 border-t pt-3 text-sm">
    <h3 className="font-semibold">{t('job.deliverables')}</h3>
    {q.isPending&&<p role="status" className="mt-2 text-muted-foreground">…</p>}
    {q.isError&&<p role="alert" className="mt-2 text-destructive">{t('job.deliverablesError')}</p>}
    {q.data?.length===0&&<p className="mt-2 text-muted-foreground">{t('job.deliverablesEmpty')}</p>}
    {!!q.data?.length&&<ul className="mt-2 divide-y">{q.data.map(d=><li key={`${d.kind}:${d.url}`} className="flex items-center justify-between gap-3 py-2">
      <span>{d.kind==='completion'?t('job.completionReport'):t('job.warrantyStatement')}{d.recorded_at?` · ${day(d.recorded_at)}`:''}</span>
      <a href={d.url} target="_blank" rel="noopener noreferrer" className="text-primary underline" aria-label={d.label}>{d.label}</a>
    </li>)}</ul>}
  </div>;
}
